import { Container, FormGroup, Label, Input } from "reactstrap";
import React, { useEffect, useState } from "react";
import { Loading } from "../../share/loading";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { useSearchParams } from "react-router-dom";
import "../../share/form.css";
import Swal from "sweetalert2";
import { NumericFormat } from "react-number-format";
import { CustomInputNumeric } from "../../share/CustomInputNumeric";
import { DatePickerInput } from "../../share/DatePickerInput";
import Modal from "react-modal";
import { CgClose } from "react-icons/cg";
import { CiExport } from "react-icons/ci";
import { getCustomStyles } from "../../share/ModalStyle";

function AutoRecalcWatcher({ foundValue }) {
    const { values, setFieldValue } = useFormikContext();

    React.useEffect(() => {
        if (values.autoCalcInstallmentAmount && !foundValue) {
            const amt = Number(values.amountApprove);
            const interest = Number(values.contactInterest);
            const installments = Number(values.installMent);

            if (!isNaN(amt) && !isNaN(interest) && !isNaN(installments) && installments > 0) {
                const result = Math.ceil((amt + (amt * interest) / 100) / installments)
                    .toFixed(2)
                    .toString();
                setFieldValue("installMentAmount", result);
            } else {
                setFieldValue("installMentAmount", "");
            }
        }
    }, [
        values.autoCalcInstallmentAmount,
        values.installMent,
        values.amountApprove,
        values.contactInterest,
        foundValue,
        setFieldValue,
    ]);

    return null;
}


export function SignBorrowContactComponent() {
    const user = JSON.parse(localStorage.getItem("userData"));
    const myCustomStyles = getCustomStyles();
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [foundValue, setFoundValue] = useState(true);
    const [data, setData] = useState(null);
    const [interestData, setinterestData] = useState([]);
    const borrowId = searchParams.get("req");
    const [openModalContact, setOpenModalContact] = useState(false);
    const ToggleModalContact = () => setOpenModalContact(!openModalContact);

    useEffect(() => {
        getDataContact();
        getInterest();
    }, []);

    async function getDataContact() {
        setLoading(true);
        let postData = new FormData();
        postData.append("borrowId", searchParams.get("req"));
        try {
            let res = await fetch(`api/ContactBorrow/getborrowContact`, {
                method: "POST",
                body: postData,
            });
            let resJson = await res.json();
            if (resJson.dataenum.contactDate === null) {
                setFoundValue(false);
            }
            setData(resJson.dataenum);
        } catch (e) {
            console.log("err =>", e);
        } finally {
            setLoading(false);
        }
    }

    async function getInterest() {
        setLoading(true);
        try {
            let responseCondition = await fetch(
                "/api/ContactBorrow/getinterestListwithdatetime"
            );
            let data = await responseCondition.json();
            setinterestData(data.dataenum);
        } catch (e) {
            console.log("err => " + e);
        } finally {
            setLoading(false);
        }
    }

    const formInitialValues = {
        amountApprove: data?.amountApprove,
        userName: user.fullName,
        borrowId: borrowId,
        contactDate: data?.contactDate ?? "",
        contactInterest: interestData[0]?.interest ?? "",
        firstPaymentDate: data?.firstPaymentDate ?? "",
        lastPaymentDate: data?.lastPaymentDate ?? "",
        dueDate: data?.dueDate ?? "",
        installMent: data?.installMent ?? "",
        installMentAmount: data?.installMentAmount ?? "",
        contactHelpStatus: data?.contactHelpStatus ?? "",
        bankForContact: data?.bankForContact ?? "",
        branchBankForContact: data?.branchBankForContact ?? "",
        payCheckContactNo: data?.payCheckContactNo ?? "",
        payCheckContactBy: data?.payCheckContactBy ?? "",
        // โหมดคำนวณจำนวนเงินต่อค่างวด: true = คำนวณอัตโนมัติ, false = กรอกเอง
        autoCalcInstallmentAmount:
            data?.installMentAmount && data?.installMent
                ? true
                : true, // ค่าเริ่มต้นให้คำนวณอัตโนมัติ
    };

    const validateSchema = Yup.object().shape({
        contactDate: Yup.date().required("กรุณากรอกข้อมูล"),
        firstPaymentDate: Yup.date()
            .when("contactDate", (contactDate, schema) =>
                contactDate &&
                schema.min(contactDate, "วันที่ชำระงวดแรก ต้องไม่น้อยกว่าวันที่ทำสัญญา")
            )
            .required("กรุณากรอกข้อมูล"),
        lastPaymentDate: Yup.date()
            .when("firstPaymentDate", (firstPaymentDate, schema) =>
                firstPaymentDate &&
                schema.min(
                    firstPaymentDate,
                    "วันที่ชำระงวดสุดท้าย ต้องไม่น้อยกว่าวันที่ทำจ่ายชำระงวดแรก"
                )
            )
            .required("กรุณากรอกข้อมูล"),
        dueDate: Yup.string().required("กรุณากรอกข้อมูล"),
        installMent: Yup.number()
            .typeError("กรุณากรอกเป็นตัวเลข")
            .positive("ต้องมากกว่า 0")
            .integer("กรุณากรอกเป็นจำนวนเต็ม")
            .required("กรุณากรอกข้อมูล"),
        contactHelpStatus: Yup.boolean(),
        bankForContact: Yup.string().required("กรุณากรอกข้อมูล"),
        branchBankForContact: Yup.string().required("กรุณากรอกข้อมูล"),
        payCheckContactNo: Yup.string()
            .matches(/^[0-9]{8}$/, "เลขที่เช็คธนาคาร ต้องเป็นตัวเลข 8 หลัก")
            .required("กรุณากรอกเลขที่เช็คธนาคาร"),
        payCheckContactBy: Yup.string().required("กรุณากรอกข้อมูล"),
        // ถ้าเลือก "กรอกเอง" ให้บังคับกรอก installMentAmount
        installMentAmount: Yup.string().when("autoCalcInstallmentAmount", {
            is: false,
            then: (schema) => schema.required("กรุณากรอกจำนวนเงินที่ต้องจ่ายในแต่ละงวด"),
            otherwise: (schema) => schema,
        }),
    });

    const ShowModalContact = () => {
        return (
            <Modal
                isOpen={openModalContact}
                onRequestClose={ToggleModalContact}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <h3 style={{ color: "#0E527E" }}>รายการสัญญา</h3>
                    <CgClose onClick={ToggleModalContact} className="style-iconmodal" />
                </div>
                <hr />
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="button"
                        className="modal-select"
                        style={{ maxWidth: "320px", width: "100%" }}
                        onClick={() => {
                            window.open(
                                `api/ContactBorrow/exportContactBorrow/${borrowId}`,
                                "_blank"
                            );
                        }}
                        download
                    >
                        <div className="d-flex flex-column align-items-center w-100">
                            <span>สัญญากู้ยืมเงิน</span>
                        </div>
                    </button>

                    {data?.checkTrainTest[0] ? (
                        <button
                            type="button"
                            className="modal-select"
                            style={{ maxWidth: "320px", width: "100%" }}
                            onClick={() => {
                                window.open(
                                    `api/ContactBorrow/exportAttatchmentTrain/${borrowId}`,
                                    "_blank"
                                );
                            }}
                        >
                            <div className="d-flex flex-column align-items-center w-100">
                                <span>เอกสารผนวก 1</span>
                                <span>สำหรับ ผู้ดำเนินการฝึก/ผู้ประกอบกิจการ</span>
                            </div>
                        </button>
                    ) : null}

                    {data?.checkTrainTest[1] ? (
                        <button
                            type="button"
                            className="modal-select"
                            style={{ maxWidth: "320px", width: "100%" }}
                            onClick={() => {
                                window.open(
                                    `api/ContactBorrow/exportAttatchmentTest/${borrowId}`,
                                    "_blank"
                                );
                            }}
                        >
                            <div className="d-flex flex-column align-items-center w-100">
                                <span>เอกสารผนวก 1</span>
                                <span>สำหรับ ผู้ดำเนินการทดสอบ/ผู้ประกอบกิจการ</span>
                            </div>
                        </button>
                    ) : null}

                    <button
                        type="button"
                        className="modal-select"
                        style={{ maxWidth: "320px", width: "100%" }}
                        onClick={() => {
                            window.open(
                                `api/ContactBorrow/exportAttatchmentExpense/${borrowId}`,
                                "_blank"
                            );
                        }}
                    >
                        <div className="d-flex flex-column align-items-center w-100">
                            <span>เอกสารผนวก 2</span>
                        </div>
                    </button>

                    <button
                        type="button"
                        className="modal-select"
                        style={{ maxWidth: "320px", width: "100%" }}
                        onClick={() => {
                            window.open(
                                `api/ContactBorrow/exportGuaranteeContact/${borrowId}`,
                                "_blank"
                            );
                        }}
                    >
                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                            <span>สัญญาค้ำประกัน</span>
                        </div>
                    </button>
                </div>
            </Modal>
        );
    };

    const onSubmit = async (values) => {
        Swal.fire({
            icon: "info",
            title: "ยืนยันการบันทึกข้อมูลหรือไม่?",
            text: "หากยืนยันการบันทึกแล้ว จะไม่สามารถแก้ไขข้อมูลได้",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#d33",
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    let res = await fetch(`api/ContactBorrow/saveSignContact`, {
                        method: "POST",
                        headers: { "Content-type": "application/json" },
                        body: JSON.stringify(values),
                    });
                    let resJson = await res.json();
                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then(() => {
                            window.location.reload();
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (e) {
                    console.log(e);
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (
        <>
            <Formik
                initialValues={formInitialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ setFieldValue, errors, touched, values, handleChange }) => {
                    // ฟังก์ชันคำนวณจำนวนเงินต่อค่างวด (ใช้เมื่อเป็นโหมดอัตโนมัติ)
                    function recalcInstallmentAmountAuto(currentValues) {
                        const amt = Number(currentValues.amountApprove);
                        const interest = Number(currentValues.contactInterest);
                        const installments = Number(currentValues.installMent);

                        if (
                            !isNaN(amt) &&
                            !isNaN(interest) &&
                            !isNaN(installments) &&
                            installments > 0
                        ) {
                            // ใช้ตรรกะเดิม: ปัดขึ้นทั้งยอดรวม/จำนวนงวด แล้ว toFixed(2)
                            const resultCalculate = Math.ceil(
                                (amt + (amt * interest) / 100) / installments
                            )
                                .toFixed(2)
                                .toString();
                            setFieldValue("installMentAmount", resultCalculate);
                        } else {
                            setFieldValue("installMentAmount", "");
                        }
                    }


                    return (
                        <>
                            <AutoRecalcWatcher foundValue={foundValue} />
                            <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                                {loading ? (
                                    <Loading />
                                ) : (
                                    <div
                                        style={{ maxWidth: "850px", width: "100%" }}
                                        className="d-flex flex-column justify-content-center align-items-center w-100"
                                    >
                                        <div className="d-flex justify-content-end w-100 mb-2">
                                            <button
                                                type="button"
                                                className={
                                                    data?.contactDate !== null ? "btn-blue mx-3" : "d-none"
                                                }
                                                onClick={() => ToggleModalContact()}
                                            >
                                                <CiExport className="text-white mx-2" size={24} />
                                                ออกสัญญา
                                            </button>
                                        </div>

                                        <div className="form-border">
                                            <Form autoComplete="off">
                                                <div className="p-5">
                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            วงเงินที่ได้รับการอนุมัติ
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="amountApprove">
                                                            {({ field, form: { values } }) => (
                                                                <NumericFormat
                                                                    {...field}
                                                                    disabled={true}
                                                                    thousandSeparator=","
                                                                    decimalScale={2}
                                                                    isNumericString={true}
                                                                    displayType="number"
                                                                    value={values.amountApprove}
                                                                    customInput={CustomInputNumeric}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            วันที่นัดทำสัญญา
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field
                                                            name="contactDate"
                                                            component={(props) => (
                                                                <DatePickerInput {...props} disable={foundValue} />
                                                            )}
                                                        />
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            วันที่กำหนดชำระของทุกเดือน
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="dueDate">
                                                            {({ field, meta }) => (
                                                                <Input
                                                                    type="select"
                                                                    disabled={foundValue}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                    {...field}
                                                                >
                                                                    <option defaultValue={"กรุณาเลือก"}>
                                                                        กรุณาเลือก
                                                                    </option>
                                                                    {Array.from({ length: 31 }, (_, i) => i + 1).map(
                                                                        (d) => (
                                                                            <option key={d} value={d}>
                                                                                {d}
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Input>
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            จำนวนงวด
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="installMent">
                                                            {({ field, meta }) => (
                                                                <Input
                                                                    type="text"
                                                                    disabled={foundValue}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                    {...field}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        // ถ้าโหมดอัตโนมัติ ให้คำนวณทันที
                                                                        if (values.autoCalcInstallmentAmount) {
                                                                            const tmp = {
                                                                                ...values,
                                                                                installMent: e.target.value,
                                                                            };
                                                                            recalcInstallmentAmountAuto(tmp);
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            อัตราดอกเบี้ย
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="contactInterest">
                                                            {({ field, meta }) => (
                                                                <Input
                                                                    type="text"
                                                                    disabled={true}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                    {...field}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    {/* โหมดการกรอกจำนวนเงินต่อค่างวด */}
                                                    <div className="d-flex justify-content-start align-items-center mb-2">
                                                        <Label className="w-50 mb-0">
                                                            วิธีระบุจำนวนเงินที่จ่ายในแต่ละงวด
                                                        </Label>
                                                        <div className="d-flex gap-4 align-items-center">
                                                            <label className="d-flex align-items-center gap-2">
                                                                <Field
                                                                    type="radio"
                                                                    name="autoCalcInstallmentAmount"
                                                                    value="true"
                                                                >
                                                                    {({ field }) => (
                                                                        <Input
                                                                            type="radio"
                                                                            {...field}
                                                                            checked={values.autoCalcInstallmentAmount === true || values.autoCalcInstallmentAmount === "true"}
                                                                            disabled={foundValue}
                                                                            onChange={() =>
                                                                                setFieldValue(
                                                                                    "autoCalcInstallmentAmount",
                                                                                    true
                                                                                )
                                                                            }
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <span className="type-register">คำนวณอัตโนมัติ</span>
                                                            </label>
                                                            <label className="d-flex align-items-center gap-2">
                                                                <Field
                                                                    type="radio"
                                                                    name="autoCalcInstallmentAmount"
                                                                    value="false"
                                                                >
                                                                    {({ field }) => (
                                                                        <Input
                                                                            type="radio"
                                                                            {...field}
                                                                            checked={values.autoCalcInstallmentAmount === false || values.autoCalcInstallmentAmount === "false"}
                                                                            disabled={foundValue}
                                                                            onChange={() =>
                                                                                setFieldValue(
                                                                                    "autoCalcInstallmentAmount",
                                                                                    false
                                                                                )
                                                                            }
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <span className="type-register">กำหนดเอง</span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="text-muted mb-3" style={{ marginLeft: "50%" }}>
                                                        {values.autoCalcInstallmentAmount
                                                            ? "ระบบจะคำนวณจาก (วงเงิน + ดอกเบี้ย) ÷ จำนวนงวด"
                                                            : "ปลดล็อคให้กรอกจำนวนเงินต่อค่างวดด้วยตนเอง"}
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            จำนวนเงินที่จ่ายในแต่ละงวด
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="installMentAmount">
                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                <NumericFormat
                                                                    {...field}
                                                                    thousandSeparator=","
                                                                    decimalScale={2}
                                                                    isNumericString={true}
                                                                    displayType="input"
                                                                    disabled={
                                                                        foundValue || values.autoCalcInstallmentAmount
                                                                    }
                                                                    customInput={CustomInputNumeric}
                                                                    value={field.value}
                                                                    onValueChange={(v) => {
                                                                        // กรอกเองเท่านั้นถึงจะเซ็ต
                                                                        if (!values.autoCalcInstallmentAmount) {
                                                                            setFieldValue(
                                                                                "installMentAmount",
                                                                                v.value ? Number(v.value).toFixed(2) : ""
                                                                            );
                                                                        }
                                                                    }}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            วันที่เริ่มจ่ายเงินงวดแรก
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field
                                                            name="firstPaymentDate"
                                                            component={(props) => (
                                                                <DatePickerInput
                                                                    {...props}
                                                                    minDate={new Date()}
                                                                    disable={foundValue}
                                                                />
                                                            )}
                                                        />
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            วันที่จ่ายเงินงวดสุดท้าย
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field
                                                            name="lastPaymentDate"
                                                            component={(props) => (
                                                                <DatePickerInput
                                                                    {...props}
                                                                    minDate={new Date()}
                                                                    disable={foundValue}
                                                                />
                                                            )}
                                                        />
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            ธนาคารที่ทำการจ่ายเช็ค
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="bankForContact">
                                                            {({ field, meta }) => (
                                                                <Input
                                                                    type="text"
                                                                    disabled={foundValue}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                    {...field}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            สาขาธนาคารที่ทำการจ่ายเช็ค
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="branchBankForContact">
                                                            {({ field, meta }) => (
                                                                <Input
                                                                    type="text"
                                                                    disabled={foundValue}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                    {...field}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            เลขที่เช็คธนาคาร
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="payCheckContactNo">
                                                            {({ field, meta }) => (
                                                                <Input
                                                                    type="text"
                                                                    maxLength={8}
                                                                    disabled={foundValue}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                    {...field}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                                        <Label className="w-50">
                                                            สั่งจ่ายเช็คในนาม
                                                            <span className="require-input">*</span>
                                                        </Label>
                                                        <Field name="payCheckContactBy">
                                                            {({ field, meta }) => (
                                                                <Input
                                                                    type="text"
                                                                    disabled={foundValue}
                                                                    className={
                                                                        meta.touched && meta.error
                                                                            ? "input-error rounded-pill text-center input-color"
                                                                            : "rounded-pill text-center input-color"
                                                                    }
                                                                    {...field}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <div className="d-flex justify-content-start align-items-center mb-3">
                                                        <span className="type-register">
                                                            มีมาตรการช่วยเหลือผู้ขอกู้ยืมหรือไม่ ?
                                                            <span className="require-input">*</span>
                                                        </span>
                                                        <div className="d-flex mx-4">
                                                            <div>
                                                                <Field name="contactHelpStatus" type="radio" value="0">
                                                                    {({ field }) => (
                                                                        <Input
                                                                            disabled={foundValue}
                                                                            type="radio"
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <span className="mx-3 type-register">ไม่มี</span>
                                                            </div>
                                                            <div>
                                                                <Field name="contactHelpStatus" type="radio" value="1">
                                                                    {({ field }) => (
                                                                        <Input
                                                                            disabled={foundValue}
                                                                            type="radio"
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <span className="mx-3 type-register">มี</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <FormGroup className="d-flex justify-content-center align-items-center">
                                                        <button
                                                            disabled={foundValue}
                                                            type="submit"
                                                            className="btn-blue w-25"
                                                        >
                                                            บันทึก
                                                        </button>
                                                    </FormGroup>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                )}
                            </Container>
                        </>

                    );
                }}
            </Formik>

            <ShowModalContact />
        </>
    );
}
